import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import {
  AvansniRacuniClient,
  IAvansniRacunTableDto
} from '@kodit/core/data-api';
import { Subscription } from 'rxjs';
import {
  RacunService,
  RacunUkupanIznosForm,
} from '../../../../../../services/src/lib/racun.service';
import { AvansnaUplataRacunaTableComponent } from './avansna-uplata-racuna-table/avansna-uplata-racuna-table.component';
import { AlertService } from '@kodit/core/services';
import { RacunInfoService } from '../../info/racun-info/racun-info.service';

@Component({
  selector: 'kodit-avansne-uplate-racuna-card',
  templateUrl: './avansne-uplate-racuna-card.component.html',
  styleUrls: ['./avansne-uplate-racuna-card.component.scss'],
})
export class AvansneUplateRacunaCardComponent implements OnInit, OnDestroy {
  private _subs: Subscription = new Subscription();
  @ViewChild('racuniTable') racuniTable: AvansnaUplataRacunaTableComponent;

  @Input() jeInfoStrana = false;
  @Output() saveAvanse = new EventEmitter<boolean>();
  @Output() cancelAvansne = new EventEmitter<boolean>();

  /** Props */
  odabraneAvansneUplateZaRacunNonModified: IAvansniRacunTableDto[] = [];
  shouldDisplayUkupanIznos: boolean;
  shouldAllowButton: boolean;
  ukupanIznos: RacunUkupanIznosForm;
  isEditing = false;

  constructor(
    private _racunService: RacunService,
    private _client: AvansniRacuniClient,
    private _alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.ukupanIznos = this._racunService.getUkupanIznos;
    if (this._racunService.shouldLoadNonModified) {
      this._loadEvidentiraneUplateRacuna();
    }

    this._subs.add(
      this._racunService.getOdabraneAvansneUplateZaRacunNonModified.subscribe(
        (res) => {
          this.odabraneAvansneUplateZaRacunNonModified = res;
          this.shouldDisplayUkupanIznos =
            res?.length > 0 && this._racunService.shouldAllowAvansneAkcije;
        }
      )
    );

    this._subs.add(
      this._racunService.getShouldUpdateAvans.subscribe((res) => {
        if (res) {
          this._racunService.setAvansneUplateRacuna = this._racunService.getAvansneUplateRacuna.map(
            (trenutnaAvansnaUplata) => {
              const nonModifiedAvansnaUplata = this.odabraneAvansneUplateZaRacunNonModified.find(
                (x) => x.id === trenutnaAvansnaUplata.avansniRacunId
              );
              return {
                id: trenutnaAvansnaUplata.id,
                avansniRacunId: trenutnaAvansnaUplata.avansniRacunId,
                avansniRacunBroj: trenutnaAvansnaUplata.avansniRacunBroj,
                avansniRacunVrsta: trenutnaAvansnaUplata.avansniRacunVrsta,
                evidentiranPdv10: nonModifiedAvansnaUplata.pdv10,
                evidentiranPdv20: nonModifiedAvansnaUplata.pdv20,
                evidentiranaOsnovica10:
                  nonModifiedAvansnaUplata.preostaloUkupnoOsnovica10,
                evidentiranaOsnovica20:
                  nonModifiedAvansnaUplata.preostaloUkupnoOsnovica20,
                evidentiranaOsnovicaAE:
                  nonModifiedAvansnaUplata.preostaloUkupnoOsnovicaAE,
                evidentiranaOsnovicaAE10:
                  nonModifiedAvansnaUplata.preostaloUkupnoOsnovicaAE10,
                evidentiranaOsnovicaAE20:
                  nonModifiedAvansnaUplata.preostaloUkupnoOsnovicaAE20,
                evidentiranaOsnovicaE:
                  nonModifiedAvansnaUplata.preostaloUkupnoOsnovicaE,
                evidentiranaOsnovicaN:
                  nonModifiedAvansnaUplata.preostaloUkupnoOsnovicaN,
                evidentiranaOsnovicaO:
                  nonModifiedAvansnaUplata.preostaloUkupnoOsnovicaO,
                evidentiranaOsnovicaOE:
                  nonModifiedAvansnaUplata.preostaloUkupnoOsnovicaOE,
                evidentiranaOsnovicaR:
                  nonModifiedAvansnaUplata.preostaloUkupnoOsnovicaR,
                evidentiranaOsnovicaSS:
                  nonModifiedAvansnaUplata.preostaloUkupnoOsnovicaSS,
                evidentiranaOsnovicaZ:
                  nonModifiedAvansnaUplata.preostaloUkupnoOsnovicaZ,
                ukupnaOsnovica8:
                  nonModifiedAvansnaUplata.ukupnaOsnovica8,
                ukupnaOsnovica10:
                  nonModifiedAvansnaUplata.ukupnaOsnovica10,
                ukupnaOsnovica20:
                  nonModifiedAvansnaUplata.ukupnaOsnovica20,
                ukupnoPdv8:
                  nonModifiedAvansnaUplata.ukupnoPdv8,
                ukupnoPdv10:
                  nonModifiedAvansnaUplata.ukupnoPdv10,
                ukupnoPdv20:
                  nonModifiedAvansnaUplata.ukupnoPdv20,
                ukupnaOsnovicaAE:
                  nonModifiedAvansnaUplata.ukupnaOsnovicaAE,
                ukupnaOsnovicaAE10:
                  nonModifiedAvansnaUplata.ukupnaOsnovicaAE10,
                ukupnaOsnovicaAE20:
                  nonModifiedAvansnaUplata.ukupnaOsnovicaAE20,
                ukupnaOsnovicaO:
                  nonModifiedAvansnaUplata.ukupnaOsnovicaO,
                ukupnaOsnovicaE:
                  nonModifiedAvansnaUplata.ukupnaOsnovicaE,
                ukupnaOsnovicaR:
                  nonModifiedAvansnaUplata.ukupnaOsnovicaR,
                ukupnaOsnovicaZ:
                  nonModifiedAvansnaUplata.ukupnaOsnovicaZ,
                ukupnaOsnovicaSS:
                  nonModifiedAvansnaUplata.ukupnaOsnovicaSS,
                ukupnaOsnovicaOE:
                  nonModifiedAvansnaUplata.ukupnaOsnovicaOE,
                ukupnaOsnovicaN:
                  nonModifiedAvansnaUplata.ukupnaOsnovicaN
              };
            }
          );
        }
      })
    );

    this.shouldAllowButton = this._racunService.shouldAllowAvansneAkcije;
  }

  startEdit() {
    this.racuniTable.editAll();
    this.isEditing = true;
  }

  saveChanges() {
    if(this._racunService.getAvansneUplateRacunaArray.invalid){
      return;
    }
    if(this._racunService.proveraIznosaAvansnihUplata()){
      this._alertService.addWarnMsg("Morate uneti jednak ili manji iznos avansa u odnosu na iznos po stopama na računu.");
      return;
    }
    if(this._racunService.getAvansneUplateRacunaArray.controls.values)
    this.racuniTable.saveAll()
    this.isEditing = false;
  }

  cancelEdit() {
    this.racuniTable.cancelAll();
    this.isEditing = false;
  }

  private _loadEvidentiraneUplateRacuna() {
    this._subs.add(
      this._client
        .getEvidentiraneUplateRacuna(
          this._racunService.getRacunFormObject.value.id
        )
        .subscribe((res) => {
          this._racunService.setOdabraneAvansneUplateZaRacunNonModified =
            res.data.responseList;
        })
    );
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }
}
